import { render, staticRenderFns } from "./PaperForm.vue?vue&type=template&id=0eb9c5f0&scoped=true"
import script from "./PaperForm.vue?vue&type=script&lang=js"
export * from "./PaperForm.vue?vue&type=script&lang=js"
import style0 from "./PaperForm.vue?vue&type=style&index=0&id=0eb9c5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb9c5f0",
  null
  
)

export default component.exports